module.exports = __webpack_public_path__ + "img/boar.5567ce94.png";